module.exports = __webpack_public_path__ + "img/intercom-old-intercom.fafe4f96.jpg";